import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["role", "tabindex", "onKeydown"]
const _hoisted_2 = { class: "flex items-start gap-3 px-4 py-4 sm:gap-4 sm:px-6 sm:py-6" }
const _hoisted_3 = { class: "min-w-0 flex-1" }
const _hoisted_4 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_5 = { class: "text-sm font-medium uppercase tracking-[0.7px] text-[#242B59]" }
const _hoisted_6 = {
  key: 0,
  class: "text-[10px] font-medium uppercase tracking-[0.55px] text-[#159A87]"
}

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { BellIcon, CursorClickIcon } from '@heroicons/vue/outline';
import type { AuraAction } from '@/types';
import AuraRichText from './AuraRichText.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraActionCard',
  props: {
    action: {},
    disabled: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["execute"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const { t } = useI18n();

const emit = __emit;

const isClickable = computed(
    () =>
        props.action.executionOwner === 'aura' &&
        Boolean(props.action.followUpQuestion?.trim()) &&
        !props.disabled &&
        !props.loading,
);

const priority = computed(() => {
    if (props.action.priority === 'high') {
        return { label: t('aura.cards.action.priority.high'), color: '#48DDC3', text: '#242B59' };
    }

    if (props.action.priority === 'low') {
        return { label: t('aura.cards.action.priority.low'), color: '#E5E7EB', text: '#626468' };
    }

    return { label: t('aura.cards.action.priority.medium'), color: '#F5B041', text: '#242B59' };
});

const actionIcon = computed(() => (isClickable.value ? CursorClickIcon : BellIcon));

const activate = () => {
    if (isClickable.value) emit('execute', props.action);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["relative box-border w-full overflow-hidden rounded-2xl border bg-white shadow-[0_1px_3px_rgba(0,0,0,0.1),0_1px_2px_-1px_rgba(0,0,0,0.1)]", 
            isClickable.value
                ? 'cursor-pointer border-[#48DDC3] bg-[#F7FFFD] transition-all hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(72,221,195,0.2)] focus:outline-none focus:ring-2 focus:ring-[#48DDC3]'
                : 'border-[#E5E7EB]'
        ]),
    role: isClickable.value ? 'button' : undefined,
    tabindex: isClickable.value ? 0 : undefined,
    onClick: activate,
    onKeydown: [
      _withKeys(_withModifiers(activate, ["prevent"]), ["enter"]),
      _withKeys(_withModifiers(activate, ["prevent"]), ["space"])
    ]
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "absolute bottom-0 left-0 top-0 w-1.5 bg-[#48DDC3]" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-[14px] shadow-[0_0_0_1px_#E5E5E5,0_1px_3px_rgba(0,0,0,0.1),0_1px_2px_-1px_rgba(0,0,0,0.1)]", isClickable.value ? 'bg-[#E6FFFA]' : 'bg-[#F5F6F8]'])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(actionIcon.value), {
          class: _normalizeClass(["h-5 w-5", isClickable.value ? 'text-[#242B59]' : 'text-[#48DDC3]']),
          "aria-hidden": "true"
        }, null, 8, ["class"]))
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('aura.cards.action.title')), 1),
          _createElementVNode("span", {
            class: "rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.7px]",
            style: _normalizeStyle({ backgroundColor: priority.value.color, color: priority.value.text })
          }, _toDisplayString(priority.value.label), 5),
          (isClickable.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('aura.cards.action.clickToAnalyze')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(AuraRichText, {
          class: "mt-2 max-w-3xl text-sm font-normal leading-[23px] text-[#626468]",
          text: _ctx.action.description
        }, null, 8, ["text"])
      ])
    ])
  ], 42, _hoisted_1))
}
}

})